<div class="modal-content">
    <!-- <app-mail-editor-modal
      [message]="message"
      [availableExpand]="false"
      (closed)="close()">
    </app-mail-editor-modal> -->
  </div>
